export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-77d04deb8014a35722cf.worker.js");
}
